import { createApp } from "vue";
import App from "./App.vue";
import mainRouter from "./router";
import { setupI18n } from "./i18n";
import VueApexCharts from "vue3-apexcharts";
import { h } from "vue";
import { message, Spin } from "ant-design-vue";
import colorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import "vue-color-kit/dist/vue-color-kit.css";
import { LoadingOutlined } from "@ant-design/icons-vue";
import { configureLocale } from "./utils/useLocale";
import { addRouteGuard } from "./service/authorization";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import piniaPersist from "pinia-plugin-persistedstate";
import { createPinia } from "pinia";
import { useUserStore } from "./store/modules/user";
import { captureReturnUrl } from "./service/returnUrl";

// Configure Spin indicator
Spin.setDefaultIndicator({
  indicator: h(LoadingOutlined),
});

// Wrap everything in an async IIFE
(async () => {
  let app;

  const pinia = createPinia();
  pinia.use(piniaPersist);

  // App creation logic

  app = createApp(App).use(pinia).use(colorPicker);
  app.config.globalProperties.$message = message;
  app.use(mainRouter);

  // Configure app plugins
  app.use(VueApexCharts);
  app.use(Antd);
  configureLocale("de");
  setupI18n(app);

  // Initialize user store and mount app
  async function init(app) {
    const store = useUserStore();
    if (store.token) {
      await store.userRequest();
    }
    if (!store.isAuthenticated) {
      // Deep link opened without a session: remember it so the login form can return
      // there instead of dropping the user on the home page.
      captureReturnUrl();
    }
    addRouteGuard(); // safe to call after user is loaded
    app.mount("#app");
  }

  await init(app);
})();
